import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { ToasterService } from '@services/toaster.service';

import { ToasterComponent } from './toaster/toaster.component';

@Component({
    selector: 'checkout-toaster-list',
    standalone: true,
    imports: [CommonModule, ToasterComponent],
    templateUrl: './toaster-list.component.html',
    styleUrl: 'toaster-list.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToasterListComponent {
    public toasterService: ToasterService = inject(ToasterService);
    public notifications$ = this.toasterService.notificationList$;
}
